var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"div1"},on:{"onmousemove":_vm.moveMouse,"mouseover":_vm.overMouse,"mouseout":_vm.outMouse}},_vm._l((_vm.hot_words),function(hot){return _c('a',{key:hot},[_vm._v(_vm._s(hot))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }